import { render } from "./ReminderEditModal.vue?vue&type=template&id=1ed45bcf&scoped=true"
import script from "./ReminderEditModal.vue?vue&type=script&lang=js"
export * from "./ReminderEditModal.vue?vue&type=script&lang=js"

import "./ReminderEditModal.vue?vue&type=style&index=0&id=1ed45bcf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ed45bcf"]])

export default __exports__